export default __webpack_public_path__ + "static/media/icn_delete.5e715cfa.svg";